import React, { useEffect, useState } from 'react';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  width?: string;
  children: React.ReactNode;
  showOverlay?: boolean;
  headerActions?: React.ReactNode;
}

const Drawer: React.FC<DrawerProps> = ({ open, onClose, title, width = '50vw', children, showOverlay = true, headerActions }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mediaQuery = window.matchMedia('(max-width: 1100px)');
    const update = () => setIsMobile(mediaQuery.matches);
    update();
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', update);
      return () => mediaQuery.removeEventListener('change', update);
    } else {
      // Safari < 14
      // @ts-ignore
      mediaQuery.addListener(update);
      return () => {
        // @ts-ignore
        mediaQuery.removeListener(update);
      };
    }
  }, []);

  const drawerStyles: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    right: 0,
    height: '100vh',
    width: isMobile ? '100vw' : width,
    minWidth: 280,
    maxWidth: isMobile ? '100vw' : 600,
    background: '#fff',
    boxShadow: '-2px 0 8px rgba(0,0,0,0.15)',
    zIndex: 1000,
    transform: open ? 'translateX(0%)' : 'translateX(100%)',
    transition: 'transform 0.3s cubic-bezier(.4,0,.2,1)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderTopLeftRadius: isMobile ? 0 : 8,
    borderBottomLeftRadius: isMobile ? 0 : 8,
    pointerEvents: open ? 'auto' : 'none',
  };
  const overlayStyles: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.2)',
    zIndex: 999,
    display: open ? 'block' : 'none',
  };

  return (
    <>
      {showOverlay && <div style={overlayStyles} onClick={onClose} />}
      <div style={drawerStyles}>
        {(title || isMobile) && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem', borderBottom: '1px solid #eee', position: 'relative' }}>
            {isMobile && (
              <button
                aria-label="Close"
                onClick={onClose}
                style={{
                  position: 'absolute',
                  left: 12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  border: 'none',
                  background: 'transparent',
                  fontSize: 22,
                  lineHeight: 1,
                  cursor: 'pointer'
                }}
              >
                ×
              </button>
            )}
            {title && (
              <h2
                style={{
                  margin: 0,
                  fontSize: '1rem',
                  fontWeight: 600,
                  color: 'var(--text)',
                  flex: 1,
                  textAlign: isMobile ? 'center' : 'left',
                  paddingLeft: isMobile ? 16 : 0,
                }}
              >
                {title}
              </h2>
            )}
            {headerActions && (
              <div style={{ display: 'flex', gap: 8 }}>
                {headerActions}
              </div>
            )}
          </div>
        )}
        <div style={{ flex: 1, overflowY: 'auto', padding: '1rem', whiteSpace: 'pre-line' }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default Drawer; 